(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zebDshCompat", [], factory);
	else if(typeof exports === 'object')
		exports["zebDshCompat"] = factory();
	else
		root["zebDshCompat"] = factory();
})(self, function() {
return 